module.exports = __webpack_public_path__ + "img/icon_certify.227905dc.png";